<template>
  <div>
    <ExamForm
        :exam_name="exam_name"
        :exam_code="exam_code"
        :component="component"
        :material="material"
        :method="method"
        :time="time"
        :scale="scale"
        v-bind:collapse-id="collapseId" v-bind:is-tuevs="isTuevs"/>

    <ExamForm v-if="sub_exam_name"
              :sub_exam_name="sub_exam_name"
              :sub_exam_code="sub_exam_code"
              :sub_exam_component="sub_exam_component"
              :sub_exam_material="sub_exam_material"
              :sub_exam_method="sub_exam_method"
              :sub_exam_time="sub_exam_time"
              :sub_exam_scale="sub_exam_scale"
              :form_group_label="$t('components.exam_wizard_form.sub_exame')" v-bind:collapse-id="collapseId" v-bind:is-tuevs="isTuevs"/>
  </div>
</template>

<script>
import ExamForm from "./ExamForm";

export default {
  name: "ExamWizardForm",
  components: {ExamForm},
  props: {
    isTuevs: Boolean,
    collapseId: String,
    exam_name: String,
    exam_code: String,
    component: String,
    material: String,
    method: String,
    time: String,
    scale: String,
    sub_exam_name: String,
    sub_exam_code: String,
    sub_exam_component: String,
    sub_exam_material: String,
    sub_exam_method: String,
    sub_exam_time: String,
    sub_exam_scale: String,
  }
}
</script>

<style scoped>
</style>